// src/RegistrationFlow.tsx
import React, { useEffect, useState } from 'react';
// import { QueryClient, QueryClientProvider } from 'react-query';
import { StepIndicator } from './components/ui/StepIndicator';
import { ContactDetailsForm } from './components/forms/ContactDetailsForm';
import { BusinessDetailsForm } from './components/forms/BusinessDetailsForm';
import { useRegistrationForm } from './hooks/useRegistrationForm';
// import type { RegistrationData } from './types/registration';
import { OwnerDetailsForm } from './components/forms/OwnerDetailsForm';
import { ProductSelectionForm } from './components/forms/ProductSelectionForm';
import { Modal } from './components/ui/Modal';
import { Spinner } from 'components';
import { useQuery } from 'react-query';
import { getCurrentStep, getFieldsSteps } from './services/api';
import { updateFormWithDbData } from './utils/registrationUtils';
import { RegistrationData } from './types/registration';

const RegistrationFlow: React.FC = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);
  const [stepWiseCompletedSteps, setStepWiseCompletedSteps] = useState<{[key: number]: Set<number>}>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const type = new URLSearchParams(window.location.search).get('type')
  const partnerId = new URLSearchParams(window.location.search).get('id')
  
  const {
    currentStep,
    steps,
    registrationData,
    nextStep,
    prevStep,
    updateData,
    setCurrentStep
  } = useRegistrationForm();
  const [exactStep, setExactStep] = useState<number | null>(null);
  const [defaultRegistrationData, setDefaultRegistrationData] = useState<Record<string, any>>({});

  const handleStepComplete = (stepData: any, loading: boolean = false) => {
    updateData(stepData);
    setCompletedSteps(prev => [...prev, currentStep]);
    setIsLoading(loading);

    if (currentStep === steps.length - 1) {
      // setShowSuccessModal(true);
    } else {
      // nextStep();
    }
  };

  const {data:stepFields} = useQuery({
    queryKey: ['getFieldsSteps'],
    queryFn: () => getFieldsSteps(),
    enabled: !!exactStep,
    onSuccess: (data) => {
      const sortedFields = data.sort((a,b)=>{
        return a.sub_step - b.sub_step;
      })
      // go upto current step and get all fields
      const currentFields = sortedFields.filter((field) => {
        return (field.sub_step) <= (exactStep || 0); // current step is 0-based
      });
      const flatAllFieldNames = currentFields.flatMap((field) => {
        return field.sub_step_field.map((f) => f.field);
      });    
      const findNextStep = sortedFields.find((field) => {
        return field.sub_step > (exactStep || 0);
      })
      if(Math.trunc(exactStep as number) === currentStep){
        setCurrentStep(Math.trunc(exactStep as number));
      }
      else
        setCurrentStep(Math.trunc(sortedFields[currentFields.length].sub_step)-1);

      const datas: Record<string, any> = {};
      flatAllFieldNames.forEach((field) => {
        datas[field] = defaultRegistrationData[field] as any;
      });
      // update step wise completed steps
      const newData = updateFormWithDbData(datas, registrationData as RegistrationData);      
      const groupedSteps = currentFields.reduce((acc, field) => {
        const mainStep = Math.trunc(field.sub_step)
        if (!acc[mainStep]) {
          acc[mainStep] = [];
        }
        if (!acc[mainStep].includes(field.sub_step)) {
          acc[mainStep].push(field.sub_step);
        }
        return acc;
      }, {} as Record<string, number[]>);
      
      // Convert Record<string, number[]> to {[key: number]: Set<number>}
      const convertedSteps = Object.entries(groupedSteps).reduce((acc, [key, value]) => {
        acc[Number(key)] = new Set(value);
        return acc;
      }, {} as {[key: number]: Set<number>});
      
      setStepWiseCompletedSteps(convertedSteps);
      updateData(newData);      
      setIsDataLoaded(true);
    }
  })  
  console.log('Step Fields:', stepWiseCompletedSteps);
  const {data:step} = useQuery({
  queryKey: ['getCurrentStep'],
  queryFn: () => getCurrentStep(partnerId || ''),  
  enabled: !!partnerId,
  onSuccess: (data) => {
    if (data?.step && steps.length > 0) { // Ensure steps array is available
      let stepIndex = Number(data.step) - 1; // Convert to 0-based index
      if( type === 'resume' && stepIndex === 0) {
        stepIndex = 1; 
      }    
      if (stepIndex >= 0 && stepIndex < steps.length) {
        setCompletedSteps(Array.from({ length: stepIndex }, (_, i) => i));
        
        localStorage.setItem('currentPartnerRegistrationId', partnerId?.toString() || '');
        setExactStep(data?.result?.reg_step || 2.1);
        setDefaultRegistrationData(data?.result || {});
      }
    }
  }
})
  const renderCurrentStep = () => {
    if (type === 'resume' && !isDataLoaded) {
      return <div className="flex justify-center items-center h-64"><Spinner /></div>;
    }
    switch (currentStep) {
      case 0:
        return (
          <ContactDetailsForm
            onSubmit={(data, isLoading) => handleStepComplete({ contactDetails: data }, isLoading)}
            onNext={nextStep}
            initialData={registrationData.contactDetails}
            defaultCompletedSteps={stepWiseCompletedSteps[1] || new Set()}
          />
        );
      case 1:
        return (
          <BusinessDetailsForm
            onSubmit={(data) => handleStepComplete({ businessDetails: data })}
            onPrevious={prevStep}
            onNext={nextStep}
            initialData={registrationData.businessDetails}
            defaultCompletedSteps={stepWiseCompletedSteps[2] || new Set()}
          />
        );
      case 2:
        return (
            <OwnerDetailsForm
                onSubmit={(data) => handleStepComplete({ ownerDetails: data })}
                onPrevious={prevStep}
                onNext={nextStep}
                initialData={registrationData?.businessDetails?.businessType?.toLowerCase().includes('individual') ? {
                    ...registrationData.ownerDetails,
                    panNumber: registrationData.businessDetails?.panNumber || '',
                } : {
                  ...registrationData.ownerDetails,
                }}
                defaultCompletedSteps={stepWiseCompletedSteps[3] || new Set()}
            />
        );
      case 3:
        return (
          <ProductSelectionForm
            onNext={nextStep}
            onSubmit={(data) => handleStepComplete({ productSelection: data })}
            onPrevious={prevStep}
            initialData={registrationData.productSelection}
            defaultCompletedSteps={stepWiseCompletedSteps[4] || new Set()}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
        {isLoading && <Spinner/>}
      <div className=" flex h-full px-4 py-8">
        <StepIndicator
          steps={steps}
          currentStep={currentStep}
          completedSteps={completedSteps}
        />
        
        <div className="rounded-lg h-full w-full px-8">
          {renderCurrentStep()}
        </div>
      </div>

      <Modal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="It's all set!"
      >
        <div className="text-center space-y-4">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto">
            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </div>
          
          <div className="space-y-2">
            <p className="text-sm text-gray-600">
              Partner ID <strong>12334</strong> {'{Business Display Name}'}
            </p>
            <p className="text-sm text-gray-600">
              Business Name <strong>{'{Legal Name}'}</strong>
            </p>
          </div>

          <div className="text-left space-y-3">
            <p className="font-medium">Now, the Partner will:</p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-center">
                <span className="w-6 h-6 bg-yellow-100 rounded mr-3 flex items-center justify-center">📧</span>
                Automatically receive login credentials on (email).
              </li>
              <li className="flex items-center">
                <span className="w-6 h-6 bg-blue-100 rounded mr-3 flex items-center justify-center">🔒</span>
                Be required to set their own password on first login.
              </li>
              <li className="flex items-center">
                <span className="w-6 h-6 bg-green-100 rounded mr-3 flex items-center justify-center">✍️</span>
                eSign contract on first time login.
              </li>
            </ul>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RegistrationFlow;